import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import app from '../../../plugins/routes/app';
import { connect } from 'react-redux';

import List from "./Address/AddressList"

class Address extends Component {

    render() {
        let trips = app.routes.find(x => x.name === 'addresses');
        return (
            <Switch>
                <Route exact path="/app/addresses" component={List} />
                {trips.routes.map((route, key) => {
                    return <Route
                        path={`${app.path}${trips.path}${route.path}`}
                        meta={route.meta}
                        component={route.component}
                        key={key}
                    />;
                })}
            </Switch>
        )
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(Address);


// WEBPACK FOOTER //
// ./src/components/App/Views/Address.js